import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import '../components/CSS/Error.css';
import { useHistory } from 'react-router-dom';
import { pageStyle } from '../components/UIComponent/CommonStyle'

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function HomePage() {
    const classes = useStyles();
    const history = useHistory();
    const linkToPage = (path) => {
        history.push(path);
    }

    return (
        <div className={classes.root}>
            <div id="main">
                <div className="fof">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <h1>404 Page Not Found</h1>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" onClick={() => linkToPage('/home')}><h4>Back to Home</h4></Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )
}